import React, {Suspense} from "react"
import "./css/App.css"
import "./css/CameraView.css"
import BoothLayout from "./components/BoothLayout"
import SplashPage from "./components/pages/SplashPage"
import CameraPage from "./components/pages/CameraPage"
import EditPage from "./components/pages/EditPage"
import WrapUpPage from "./components/pages/WrapUpPage"
import GuestInputPage from "./components/pages/GuestInputPage"
import ProcessingPage from "./components/pages/ProcessingPage"
import PicPage from "./components/pages/PicPage"
import {BrowserRouter as Router, Route, Routes} from "react-router-dom"
import {API} from "@simplebooth/webkit"
import PageNotFound from "./components/views/PageNotFound"
import ModalTestPage from "./components/pages/ModalTestPage"

function App() {
  const baseUrl = process.env.REACT_APP_API_BASE_URL as string
  API.configure(baseUrl)

  return (
    <>
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cloud.typography.com/6633494/6612752/css/fonts.css"
      />
      <Suspense fallback="loading">
        <Router>
          <Routes>
            <Route element={<BoothLayout/>}>
              <Route
                path="/:code"
                element={<SplashPage/>}
              />
              <Route
                path="/:code/camera"
                element={<CameraPage/>}
              />
              <Route
                path="/:code/guest-input"
                element={<GuestInputPage/>}
              />
              <Route
                path="/:code/photo-processing"
                element={<ProcessingPage/>}
              />
              <Route
                path="/:code/edit"
                element={<EditPage/>}
              />
              <Route
                path="/:code/wrap-up"
                element={<WrapUpPage/>}
              />
              <Route
                path="/:code/pic/:uploadCode"
                element={<PicPage/>}
              />
              <Route
                path="/:code/pic/:uploadCode/:picPresentation"
                element={<PicPage/>}
              />
            </Route>
            <Route
              path="/modals"
              element={<ModalTestPage/>}
            />
            <Route
              path="*"
              element={<PageNotFound/>}
            />
          </Routes>
        </Router>
      </Suspense>
    </>
  )
}

export default App
